<ng-container *transloco="let t">
  <td iTableTd class="max-w-0">
    @if (defaultTactic()) {
      <span class="truncate">{{ t("sd-targeting.ai-powered_targeting") }}</span>
    } @else if (tactic()) {
      <span class="truncate">{{ segment()?.name }}</span>
    } @else if (audience(); as audience) {
      <span class="truncate">{{
        t("sd-targeting.last_days", [
          audience.expressionType | titlecase,
          supportedAudienceMatchType[audience.matchType!],
          audience.lookback,
        ])
      }}</span>
    }
  </td>

  <td iTableTd>
    <IBadge color="gray" size="xs" [label]="t(typeLabelKey())" />
  </td>

  <td iTableTd>
    @if (!isReadOnly()) {
      <div class="flex w-full justify-end">
        <button
          iButton
          [iDropdownMenuTrigger]="rowMenu"
          color="gray"
          variant="ghost"
          size="sm"
          class="opacity-0 group-hover:opacity-100"
          placement="bottom-end"
          (click)="$event.stopPropagation()"
        >
          <IIcon name="ellipsis" />
        </button>
      </div>

      <ng-template #rowMenu>
        <IDropdownMenu class="w-[230px]">
          @if (canEditSegment()) {
            <button iDropdownMenuItem (click)="editSegment()">
              <IIcon name="edit" />
              {{ t("sd-targeting.update_tactic_segment") }}
            </button>
          }
          <button
            iDropdownMenuItem
            variant="danger"
            [disabled]="isDeleteDisabled()"
            [iTooltip]="isDeleteDisabled() ? t('sd-targeting.delete_targeting') : undefined"
            iTooltipPlacement="left-center"
            (click)="onDelete()"
          >
            <IIcon name="trash" />
            {{ t("common.delete") }}
          </button>
        </IDropdownMenu>
      </ng-template>
    }
  </td>
</ng-container>
